import type { StateCreator } from 'zustand';
import { create as zustandCreate } from 'zustand';

export type ZustandLocalStorageState<T> = {
  state: T;
  version: number;
};

const storeResetFns = new Set<() => void>();

export const create = (<T>() => {
  return (stateCreator: StateCreator<T>) => {
    const store = zustandCreate(stateCreator);

    storeResetFns.add(() => {
      store.setState(store.getInitialState(), true);
    });
    return store;
  };
}) as typeof zustandCreate;

export const resetAllStores = () => {
  storeResetFns.forEach((resetFn) => {
    resetFn();
  });
};
